var handle_array = ["accoya","cumaru","yellow-balau"];
 var hide_price=1;
 var hide_ajaxaddtocart =1;
 var display_phone = 0;
 var phone_no='';
 var display_call_for_price=1;
 var call_for_price_label = 'Contact us for details';
 var css_style_button='';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = 'Phone Number';
 var comment_label = 'Message';
 var submit_label ='Submit';
 var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
 var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = '';
 var required_field='name';
 var contact_form_heading='Request for information for';
 var parent_selector='';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
